import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { trackPageView } from '../analytics';
import { ROUTES } from '../routing';

export default function useTrackNavigationChanges() {
  const history = useHistory();

  useEffect(() => {
    if (
      !window.location.pathname.includes(
        ROUTES.PUBLIC.SQL_PLAYROUND.getPath()
      ) &&
      !window.location.pathname.includes(
        ROUTES.PUBLIC.PYTHON_PLAYROUND_EMBED.getPath()
      ) &&
      !window.location.pathname.includes(
        ROUTES.PUBLIC.SQL_PLAYROUND_EMBED.getPath()
      )
    ) {
      trackPageView();
    }
    history.listen(() => trackPageView());
  }, [history]);
  return null;
}
